import { h, Component } from "preact";

export type NavBarButtonTypes = "BACK" | "FORCE_REFRESH";

interface NavBarProps {
    buttonsToShow: NavBarButtonTypes[];
    children?: any;
}

function contains<T>(haystack: T[], needle: T) {
    return haystack.indexOf(needle) !== -1;
}

export const NavBar = ({ buttonsToShow, children }: NavBarProps) => <div class="navbar">
    {children}
    {contains(buttonsToShow, "BACK") && <button class="btn" style={{ float: "left" }} onClick={() => history.back()}>
        Back
    </button>}
    {contains(buttonsToShow, "FORCE_REFRESH") && <button class="btn" style={{ float: "right" }} onClick={() => { caches.delete("hn-cache"); location.reload(); }}>
        Force refresh
    </button>}
</div>;
